// The host screen's "Sparka" on a seat, in the waiting room and on the board. Two taps:
// the controller arms it on the first and kicks on the second, and says which it is.
export function KickButton({controller, player}) {
  const kick = controller.kickButton(player);
  if (!kick) return null;
  return (
    <button
      className={kick.armed ? "kick-button armed" : "kick-button"}
      type="button"
      aria-label={`${kick.label} ${player.name}`}
      onClick={() => controller.kickPlayer(player.id)}
    >
      {kick.label}
    </button>
  );
}
